// import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes, faCrown, faStar, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
// import axiosInstance from '../Datas/AxiosConfig';
// import styles from '../Styles/PromotionalBanner.module.scss';

// interface VIPCraftsman {
//   id: number;
//   external_id: string;
//   first_name: string;
//   last_name: string;
//   profession: string;
//   city: string;
//   experience: string;
//   price: string;
//   profile_img: string | null;
//   average_rating: number;
//   total_ratings: number;
//   verification: boolean;
//   vip_package_name: string | null;
//   days_remaining: number;
// }

// interface PromotionalResponse {
//   success: boolean;
//   total_vip_craftsmen: number;
//   remaining_unseen: number;
//   craftsman: VIPCraftsman;
//   next_shown_ids: string;
//   cycle_completed: boolean;
// }

// // ✅ Move helper functions outside component to prevent re-creation
// const getBannerHistory = () => {
//   try {
//     const stored = localStorage.getItem('promotionalBannerHistory');
//     return stored ? JSON.parse(stored) : { lastShown: 0, shownCraftsmenIds: '' };
//   } catch {
//     return { lastShown: 0, shownCraftsmenIds: '' };
//   }
// };

// const updateBannerHistory = (craftsmanId: number, nextShownIds: string) => {
//   const history = {
//     lastShown: Date.now(),
//     shownCraftsmenIds: nextShownIds
//   };
//   localStorage.setItem('promotionalBannerHistory', JSON.stringify(history));
// };

// const checkMarketingConsent = (): boolean => {
//   const cookiesAccepted = localStorage.getItem('cookiesAccepted');
//   const marketingEnabled = localStorage.getItem('marketingEnabled');
//   return cookiesAccepted === 'all' || 
//          (cookiesAccepted === 'custom' && marketingEnabled === 'true');
// };

// const shouldShowBanner = (): boolean => {
//   if (!checkMarketingConsent()) {
//     return false;
//   }
  
//   const history = getBannerHistory();
//   const oneHourInMs = 60 * 60 * 1000;
//   const timeSinceLastShown = Date.now() - history.lastShown;
  
//   return timeSinceLastShown >= oneHourInMs;
// };

// let renderCount = 0;

// // ✅ Component with props interface for better debugging
// interface PromotionalBannerProps {
//   // Add any props from parent components here to track them
// }

// // ✅ Enhanced debugging for memo comparison
// const PromotionalBanner: React.FC<PromotionalBannerProps> = React.memo(
//   (props) => {
//     renderCount++;
//     console.log(`🎯 PromotionalBanner RENDER #${renderCount} at ${new Date().toLocaleTimeString()}`);
    
//     // ✅ Log what caused this render (development only)
//     if (process.env.NODE_ENV === 'development') {
//       console.log('🔍 Render caused by props:', props);
//     }

//     const [isVisible, setIsVisible] = useState<boolean>(false);
//     const [craftsman, setCraftsman] = useState<VIPCraftsman | null>(null);
    
//     // Refs for stable references
//     const timerRef = useRef<NodeJS.Timeout | null>(null);
//     const cookieWatcherRef = useRef<NodeJS.Timeout | null>(null);
//     const componentMountedRef = useRef<boolean>(true);
//     const lastConsentCheckRef = useRef<boolean>(false);
//     const lastActivityRef = useRef<number>(Date.now());
    
//     // ✅ NEW: Track visibility state to prevent rapid switching
//     const isPageVisibleRef = useRef<boolean>(!document.hidden);
//     const visibilityTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    
//     // ✅ Track previous state for debugging
//     const prevStateRef = useRef({ isVisible, craftsman });
//     useEffect(() => {
//       const prevState = prevStateRef.current;
//       if (prevState.isVisible !== isVisible) {
//         console.log(`🔄 State change: isVisible ${prevState.isVisible} → ${isVisible}`);
//       }
//       if (prevState.craftsman !== craftsman) {
//         console.log(`🔄 State change: craftsman changed`, {
//           from: prevState.craftsman?.first_name || 'null',
//           to: craftsman?.first_name || 'null'
//         });
//       }
//       prevStateRef.current = { isVisible, craftsman };
//     });
    
//     // ✅ Stable function using useCallback
//     const fetchPromotionalCraftsman = useCallback(async (): Promise<void> => {
//       console.log(`🌐 fetchPromotionalCraftsman called`);
      
//       if (!shouldShowBanner() || !componentMountedRef.current) {
//         console.log(`🌐 fetchPromotionalCraftsman cancelled`);
//         return;
//       }

//       try {
//         console.log(`🌐 API call starting...`);
//         const history = getBannerHistory();
//         const url = history.shownCraftsmenIds 
//           ? `vip/promotional/craftsmen/?shown=${history.shownCraftsmenIds}`
//           : 'vip/promotional/craftsmen/';

//         console.log(`🌐 API URL: ${url}`);
//         const response = await axiosInstance.get<PromotionalResponse>(url);

//         if (response.data.success && response.data.craftsman && componentMountedRef.current) {
//           console.log(`✅ Setting craftsman: ${response.data.craftsman.first_name} ${response.data.craftsman.last_name}`);
//           setCraftsman(response.data.craftsman);
//           setIsVisible(true);
          
//           updateBannerHistory(
//             response.data.craftsman.id, 
//             response.data.next_shown_ids
//           );
          
//           console.log(`📢 Promotional banner shown: ${response.data.craftsman.first_name} ${response.data.craftsman.last_name}`);
//         } else {
//           console.log(`❌ API response invalid or component unmounted`);
//         }
//       } catch (err: any) {
//         console.error('💥 Error fetching promotional craftsman:', err);
//       }
//     }, []);

//     // ✅ Stable user activity handler
//     const handleUserActivity = useCallback(() => {
//       lastActivityRef.current = Date.now();
//     }, []);

//     // ✅ Check if user is active
//     const isUserActive = useCallback((): boolean => {
//       const fiveMinutesInMs = 5 * 60 * 1000;
//       const timeSinceActivity = Date.now() - lastActivityRef.current;
//       return timeSinceActivity < fiveMinutesInMs;
//     }, []);

//     // ✅ Stable timer function
//     const startPromotionalTimer = useCallback(() => {
//       console.log(`⏱️ Starting promotional timer...`);
//       if (timerRef.current) {
//         console.log(`⏱️ Clearing existing timer`);
//         clearInterval(timerRef.current);
//       }

//       timerRef.current = setInterval(() => {
//         console.log(`⏱️ Timer tick - checking conditions...`);
        
//         if (!componentMountedRef.current) {
//           console.log(`⏱️ Skip: component not mounted`);
//           return;
//         }
        
//         // ✅ Use ref instead of document.hidden for stability
//         if (!isPageVisibleRef.current) {
//           console.log(`⏱️ Skip: page not visible`);
//           return;
//         }
        
//         if (!isUserActive()) {
//           console.log(`⏱️ Skip: user not active`);
//           return;
//         }
        
//         if (!checkMarketingConsent()) {
//           console.log(`⏱️ Skip: no marketing consent`);
//           return;
//         }

//         if (shouldShowBanner()) {
//           console.log(`⏱️ All checks passed - fetching craftsman`);
//           fetchPromotionalCraftsman();
//         } else {
//           console.log(`⏱️ Should not show banner yet`);
//         }
//       }, 60000); // ყოველ წუთში
      
//       console.log(`⏱️ Timer started with ID: ${timerRef.current}`);
//     }, [fetchPromotionalCraftsman, isUserActive]);

//     // ✅ IMPROVED: Debounced visibility change handler
//     const handleVisibilityChange = useCallback(() => {
//       const currentlyVisible = !document.hidden;
      
//       // ✅ Clear any pending visibility timeout
//       if (visibilityTimeoutRef.current) {
//         clearTimeout(visibilityTimeoutRef.current);
//       }
      
//       // ✅ Only process if visibility actually changed
//       if (currentlyVisible === isPageVisibleRef.current) {
//         return;
//       }
      
//       console.log(`👁️ Page visibility changing to: ${currentlyVisible ? 'visible' : 'hidden'}`);
      
//       // ✅ Add debounce to prevent rapid switching
//       visibilityTimeoutRef.current = setTimeout(() => {
//         if (!componentMountedRef.current) return;
        
//         // ✅ Double-check visibility hasn't changed again
//         const stillVisible = !document.hidden;
//         if (stillVisible !== currentlyVisible) {
//           console.log(`👁️ Visibility changed again during debounce, cancelling`);
//           return;
//         }
        
//         isPageVisibleRef.current = stillVisible;
//         console.log(`👁️ Page visibility confirmed: ${stillVisible ? 'visible' : 'hidden'}`);
        
//         if (!stillVisible) {
//           if (timerRef.current) {
//             console.log(`⏸️ Pausing timer (page hidden)`);
//             clearInterval(timerRef.current);
//             timerRef.current = null;
//           }
//         } else {
//           console.log(`▶️ Resuming timer (page visible)`);
//           // Add delay to prevent immediate restart during rapid changes
//           setTimeout(() => {
//             if (componentMountedRef.current && isPageVisibleRef.current) {
//               startPromotionalTimer();
//             }
//           }, 2000); // 2 second delay
//         }
//       }, 1000); // 1 second debounce
//     }, [startPromotionalTimer]);

//     // ✅ Optimized cookie watcher
//     const startCookieWatcher = useCallback(() => {
//       if (cookieWatcherRef.current) {
//         clearInterval(cookieWatcherRef.current);
//       }

//       lastConsentCheckRef.current = checkMarketingConsent();

//       cookieWatcherRef.current = setInterval(() => {
//         if (!componentMountedRef.current) return;
        
//         const currentConsent = checkMarketingConsent();
        
//         if (currentConsent !== lastConsentCheckRef.current) {
//           console.log(`🍪 Marketing consent changed: ${currentConsent}`);
//           lastConsentCheckRef.current = currentConsent;
          
//           if (currentConsent && shouldShowBanner()) {
//             setTimeout(() => {
//               fetchPromotionalCraftsman();
//             }, 500);
//           }
          
//           if (currentConsent && cookieWatcherRef.current) {
//             clearInterval(cookieWatcherRef.current);
//             cookieWatcherRef.current = null;
//           }
//         }
//       }, 5000); // 5 seconds interval
//     }, [fetchPromotionalCraftsman]);

//     // ✅ Single useEffect for component lifecycle
//     useEffect(() => {
//       componentMountedRef.current = true;
//       isPageVisibleRef.current = !document.hidden;

//       // Event listeners
//       document.addEventListener('visibilitychange', handleVisibilityChange, { passive: true });
//       document.addEventListener('mousemove', handleUserActivity, { passive: true });
//       document.addEventListener('keypress', handleUserActivity, { passive: true });
//       document.addEventListener('scroll', handleUserActivity, { passive: true });
//       document.addEventListener('click', handleUserActivity, { passive: true });

//       // Initial check
//       if (shouldShowBanner()) {
//         fetchPromotionalCraftsman();
//       }

//       // Start timers only if page is visible
//       if (isPageVisibleRef.current) {
//         startPromotionalTimer();
//       }
      
//       if (!checkMarketingConsent()) {
//         startCookieWatcher();
//       }

//       return () => {
//         componentMountedRef.current = false;
        
//         // Event listeners cleanup
//         document.removeEventListener('visibilitychange', handleVisibilityChange);
//         document.removeEventListener('mousemove', handleUserActivity);
//         document.removeEventListener('keypress', handleUserActivity);
//         document.removeEventListener('scroll', handleUserActivity);
//         document.removeEventListener('click', handleUserActivity);

//         // Timers cleanup
//         if (timerRef.current) {
//           clearInterval(timerRef.current);
//           timerRef.current = null;
//         }
        
//         if (cookieWatcherRef.current) {
//           clearInterval(cookieWatcherRef.current);
//           cookieWatcherRef.current = null;
//         }
        
//         if (visibilityTimeoutRef.current) {
//           clearTimeout(visibilityTimeoutRef.current);
//           visibilityTimeoutRef.current = null;
//         }
//       };
//     }, [handleVisibilityChange, handleUserActivity, fetchPromotionalCraftsman, startPromotionalTimer, startCookieWatcher]);

//     // ✅ Stable banner actions using useCallback
//     const handleClose = useCallback(() => {
//       setIsVisible(false);
//       setCraftsman(null);
//     }, []);

//     const handleViewProfile = useCallback(() => {
//       if (craftsman) {
//         window.open(`/craftsman/${craftsman.external_id}`, '_blank');
//         handleClose();
//       }
//     }, [craftsman, handleClose]);

//     // ✅ VIP badge styling - memoized
//     const vipBadgeClass = useMemo(() => {
//       const packageName = craftsman?.vip_package_name;
//       switch (packageName?.toLowerCase()) {
//         case 'platinum': return styles['vipBadge--platinum'];
//         case 'diamond': return styles['vipBadge--diamond'];
//         case 'gold': return styles['vipBadge--gold'];
//         case 'silver': return styles['vipBadge--silver'];
//         case 'bronze': return styles['vipBadge--bronze'];
//         default: return styles['vipBadge--default'];
//       }
//     }, [craftsman?.vip_package_name]);

//     // ✅ Early return - no unnecessary JSX creation
//     if (!isVisible || !craftsman) {
//       return null;
//     }

//     return (
//       <div className={styles.bannerOverlay}>
//         <div className={styles.bannerContainer}>
//           <div className={styles.banner}>
//             <button 
//               className={styles.closeButton}
//               onClick={handleClose}
//               aria-label="ბანერის დახურვა"
//             >
//               <FontAwesomeIcon icon={faTimes} />
//             </button>

//             <div className={`${styles.vipBadge} ${vipBadgeClass}`}>
//               <FontAwesomeIcon icon={faCrown} className={styles.crownIcon} />
//               <span>{craftsman.vip_package_name}</span>
//             </div>

//             <div className={styles.content}>
//               <div className={styles.imageContainer}>
//                 {craftsman.profile_img && (
//                   <img 
//                     src={craftsman.profile_img}
//                     alt={`${craftsman.first_name} ${craftsman.last_name}`}
//                     className={styles.profileImage}
//                     loading="lazy"
//                   />
//                 )}
//                 {!craftsman.profile_img && (
//                   <div className={styles.profileImagePlaceholder}>
//                     <FontAwesomeIcon icon={faCrown} />
//                   </div>
//                 )}
//                 {craftsman.verification && (
//                   <div className={styles.verificationBadge}>✓</div>
//                 )}
//               </div>

//               <div className={styles.info}>
//                 <h3 className={styles.name}>
//                   {craftsman.first_name} {craftsman.last_name}
//                 </h3>
                
//                 <div className={styles.details}>
//                   <div className={styles.profession}>
//                     <FontAwesomeIcon icon={faCrown} className={styles.icon} />
//                     <span>{craftsman.profession}</span>
//                   </div>
                  
//                   <div className={styles.location}>
//                     <FontAwesomeIcon icon={faMapMarkerAlt} className={styles.icon} />
//                     <span>{craftsman.city}</span>
//                   </div>
                  
//                   {craftsman.total_ratings > 0 && (
//                     <div className={styles.rating}>
//                       <FontAwesomeIcon icon={faStar} className={styles.icon} />
//                       <span>{craftsman.average_rating}/10 ({craftsman.total_ratings})</span>
//                     </div>
//                   )}
//                 </div>

//                 <div className={styles.experience}>
//                   გამოცდილება: {craftsman.experience}
//                 </div>

//                 <div className={styles.price}>
//                   ფასი: {craftsman.price}
//                 </div>
//               </div>
//             </div>

//             <div className={styles.actions}>
//               <button 
//                 className={styles.viewProfileButton}
//                 onClick={handleViewProfile}
//               >
//                 პროფილის ნახვა
//               </button>
//             </div>

//             <div className={styles.footer}>
//               <span className={styles.vipLabel}>VIP ხელოსანი</span>
//               <span className={styles.daysRemaining}>
//                 {craftsman.days_remaining} დღე დარჩენილია
//               </span>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   },
//   // ✅ Custom comparison function for debugging
//   (prevProps, nextProps) => {
//     // In development, log what changed
//     if (process.env.NODE_ENV === 'development') {
//       const propsChanged = Object.keys(nextProps).some(
//         key => prevProps[key as keyof PromotionalBannerProps] !== nextProps[key as keyof PromotionalBannerProps]
//       );
      
//       if (propsChanged) {
//         console.log('🔄 PromotionalBanner props changed:', {
//           prevProps,
//           nextProps
//         });
//         return false; // Component should re-render
//       } else {
//         console.log('✅ PromotionalBanner props unchanged - skipping render');
//         return true; // Component should NOT re-render
//       }
//     }
    
//     // In production, do shallow comparison
//     return Object.keys(nextProps).every(
//       key => prevProps[key as keyof PromotionalBannerProps] === nextProps[key as keyof PromotionalBannerProps]
//     );
//   }
// );

// // ✅ Add display name for debugging
// PromotionalBanner.displayName = 'PromotionalBanner';

// export default PromotionalBanner;





//////////////////////////////
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faCrown, faStar, faMapMarkerAlt, faShield, faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import axiosInstance from '../Datas/AxiosConfig';
import styles from '../Styles/PromotionalBanner.module.scss';

interface VIPCraftsman {
  id: number;
  external_id: string;
  first_name: string;
  last_name: string;
  profession: string;
  city: string;
  experience: string;
  price: string;
  profile_img: string | null;
  average_rating: number;
  total_ratings: number;
  verification: boolean;
  vip_package_name: string | null;
  days_remaining: number;
}

interface PromotionalResponse {
  success: boolean;
  total_vip_craftsmen: number;
  remaining_unseen: number;
  craftsman: VIPCraftsman;
  next_shown_ids: string;
  cycle_completed: boolean;
}

// Helper functions outside component to prevent re-creation
const getBannerHistory = () => {
  try {
    const stored = localStorage.getItem('promotionalBannerHistory');
    return stored ? JSON.parse(stored) : { lastShown: 0, shownCraftsmenIds: '' };
  } catch {
    return { lastShown: 0, shownCraftsmenIds: '' };
  }
};

const updateBannerHistory = (craftsmanId: number, nextShownIds: string) => {
  const history = {
    lastShown: Date.now(),
    shownCraftsmenIds: nextShownIds
  };
  localStorage.setItem('promotionalBannerHistory', JSON.stringify(history));
};

const checkMarketingConsent = (): boolean => {
  const cookiesAccepted = localStorage.getItem('cookiesAccepted');
  const marketingEnabled = localStorage.getItem('marketingEnabled');
  return cookiesAccepted === 'all' || 
         (cookiesAccepted === 'custom' && marketingEnabled === 'true');
};

const shouldShowBanner = (): boolean => {
  if (!checkMarketingConsent()) {
    return false;
  }
  
  const history = getBannerHistory();
  const oneHourInMs = 60 * 60 * 1000;
  const timeSinceLastShown = Date.now() - history.lastShown;
  
  return timeSinceLastShown >= oneHourInMs;
};

const PromotionalBanner: React.FC = React.memo(() => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [craftsman, setCraftsman] = useState<VIPCraftsman | null>(null);

  const serverBaseUrl = "https://xeloba.ge/";
  // const serverBaseUrl = "http://localhost:8000/"
  
  // Refs for stable references
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const cookieWatcherRef = useRef<NodeJS.Timeout | null>(null);
  const componentMountedRef = useRef<boolean>(true);
  const lastConsentCheckRef = useRef<boolean>(false);
  const lastActivityRef = useRef<number>(Date.now());
  const isPageVisibleRef = useRef<boolean>(!document.hidden);
  const visibilityTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  
  // Stable function using useCallback
  const fetchPromotionalCraftsman = useCallback(async (): Promise<void> => {
    if (!shouldShowBanner() || !componentMountedRef.current) {
      return;
    }

    try {
      const history = getBannerHistory();
      const url = history.shownCraftsmenIds 
        ? `vip/promotional/craftsmen/?shown=${history.shownCraftsmenIds}`
        : 'vip/promotional/craftsmen/';

      const response = await axiosInstance.get<PromotionalResponse>(url);

      if (response.data.success && response.data.craftsman && componentMountedRef.current) {
        setCraftsman(response.data.craftsman);
        setIsVisible(true);
        
        updateBannerHistory(
          response.data.craftsman.id, 
          response.data.next_shown_ids
        );
      }
    } catch (err: any) {
      console.error('Error fetching promotional craftsman:', err);
    }
  }, []);

  // Stable user activity handler
  const handleUserActivity = useCallback(() => {
    lastActivityRef.current = Date.now();
  }, []);

  // Check if user is active
  const isUserActive = useCallback((): boolean => {
    const fiveMinutesInMs = 5 * 60 * 1000;
    const timeSinceActivity = Date.now() - lastActivityRef.current;
    return timeSinceActivity < fiveMinutesInMs;
  }, []);

  // Stable timer function
  const startPromotionalTimer = useCallback(() => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    timerRef.current = setInterval(() => {
      if (!componentMountedRef.current) return;
      if (!isPageVisibleRef.current) return;
      if (!isUserActive()) return;
      if (!checkMarketingConsent()) return;

      if (shouldShowBanner()) {
        fetchPromotionalCraftsman();
      }
    }, 60000); // Every minute
  }, [fetchPromotionalCraftsman, isUserActive]);

  // Debounced visibility change handler
  const handleVisibilityChange = useCallback(() => {
    const currentlyVisible = !document.hidden;
    
    // Clear any pending visibility timeout
    if (visibilityTimeoutRef.current) {
      clearTimeout(visibilityTimeoutRef.current);
    }
    
    // Only process if visibility actually changed
    if (currentlyVisible === isPageVisibleRef.current) {
      return;
    }
    
    // Add debounce to prevent rapid switching
    visibilityTimeoutRef.current = setTimeout(() => {
      if (!componentMountedRef.current) return;
      
      // Double-check visibility hasn't changed again
      const stillVisible = !document.hidden;
      if (stillVisible !== currentlyVisible) {
        return;
      }
      
      isPageVisibleRef.current = stillVisible;
      
      if (!stillVisible) {
        if (timerRef.current) {
          clearInterval(timerRef.current);
          timerRef.current = null;
        }
      } else {
        // Add delay to prevent immediate restart during rapid changes
        setTimeout(() => {
          if (componentMountedRef.current && isPageVisibleRef.current) {
            startPromotionalTimer();
          }
        }, 2000); // 2 second delay
      }
    }, 1000); // 1 second debounce
  }, [startPromotionalTimer]);

  // Optimized cookie watcher
  const startCookieWatcher = useCallback(() => {
    if (cookieWatcherRef.current) {
      clearInterval(cookieWatcherRef.current);
    }

    lastConsentCheckRef.current = checkMarketingConsent();

    cookieWatcherRef.current = setInterval(() => {
      if (!componentMountedRef.current) return;
      
      const currentConsent = checkMarketingConsent();
      
      if (currentConsent !== lastConsentCheckRef.current) {
        lastConsentCheckRef.current = currentConsent;
        
        if (currentConsent && shouldShowBanner()) {
          setTimeout(() => {
            fetchPromotionalCraftsman();
          }, 500);
        }
        
        if (currentConsent && cookieWatcherRef.current) {
          clearInterval(cookieWatcherRef.current);
          cookieWatcherRef.current = null;
        }
      }
    }, 5000); // 5 seconds interval
  }, [fetchPromotionalCraftsman]);

  // Component lifecycle
  useEffect(() => {
    componentMountedRef.current = true;
    isPageVisibleRef.current = !document.hidden;

    // Event listeners
    document.addEventListener('visibilitychange', handleVisibilityChange, { passive: true });
    document.addEventListener('mousemove', handleUserActivity, { passive: true });
    document.addEventListener('keypress', handleUserActivity, { passive: true });
    document.addEventListener('scroll', handleUserActivity, { passive: true });
    document.addEventListener('click', handleUserActivity, { passive: true });

    // Initial check
    if (shouldShowBanner()) {
      fetchPromotionalCraftsman();
    }

    // Start timers only if page is visible
    if (isPageVisibleRef.current) {
      startPromotionalTimer();
    }
    
    if (!checkMarketingConsent()) {
      startCookieWatcher();
    }

    return () => {
      componentMountedRef.current = false;
      
      // Event listeners cleanup
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      document.removeEventListener('mousemove', handleUserActivity);
      document.removeEventListener('keypress', handleUserActivity);
      document.removeEventListener('scroll', handleUserActivity);
      document.removeEventListener('click', handleUserActivity);

      // Timers cleanup
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
      
      if (cookieWatcherRef.current) {
        clearInterval(cookieWatcherRef.current);
        cookieWatcherRef.current = null;
      }
      
      if (visibilityTimeoutRef.current) {
        clearTimeout(visibilityTimeoutRef.current);
        visibilityTimeoutRef.current = null;
      }
    };
  }, [handleVisibilityChange, handleUserActivity, fetchPromotionalCraftsman, startPromotionalTimer, startCookieWatcher]);

  // Stable banner actions using useCallback
  const handleClose = useCallback(() => {
    setIsVisible(false);
    setCraftsman(null);
  }, []);

  const handleViewProfile = useCallback(() => {
    if (craftsman) {
      navigate(`/craftsman/${craftsman.external_id}`);
      handleClose();
    }
  }, [craftsman, handleClose, navigate]);

  // VIP badge styling - memoized
  const vipBadgeClass = useMemo(() => {
    const packageName = craftsman?.vip_package_name;
    switch (packageName?.toLowerCase()) {
      case 'platinum': return styles['vipBadge--platinum'];
      case 'diamond': return styles['vipBadge--diamond'];
      case 'gold': return styles['vipBadge--gold'];
      case 'silver': return styles['vipBadge--silver'];
      case 'bronze': return styles['vipBadge--bronze'];
      default: return styles['vipBadge--default'];
    }
  }, [craftsman?.vip_package_name]);

  // Format rating display
  const formattedRating = useMemo(() => {
    if (!craftsman || craftsman.total_ratings === 0) return null;
    return `${craftsman.average_rating}/10 (${craftsman.total_ratings} შეფასება)`;
  }, [craftsman?.average_rating, craftsman?.total_ratings]);

  // Early return - no unnecessary JSX creation
  if (!isVisible || !craftsman) {
    return null;
  }

  return (
    <div className={styles.bannerOverlay}>
      <div className={styles.bannerContainer}>
        <div className={styles.banner}>
          <button 
            className={styles.closeButton}
            onClick={handleClose}
            aria-label="ბანერის დახურვა"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>

          <div className={`${styles.vipBadge} ${vipBadgeClass}`}>
            <FontAwesomeIcon icon={faCrown} className={styles.crownIcon} />
            <span>{craftsman.vip_package_name || 'VIP'}</span>
          </div>

          {/* Header */}
          <div className={styles.header}>
            <span className={styles.recommendationLabel}>
              ✨ რეკომენდაცია
            </span>
          </div>

          <div className={styles.content}>
            <div className={styles.imageContainer}>
              {craftsman.profile_img && (
                <img 
                  src={`${serverBaseUrl}${craftsman.profile_img}`}
                  alt={`${craftsman.first_name} ${craftsman.last_name}`}
                  className={styles.profileImage}
                  loading="lazy"
                />
              )}
              {!craftsman.profile_img && (
                <div className={styles.profileImagePlaceholder}>
                  <FontAwesomeIcon icon={faCrown} />
                </div>
              )}
              {craftsman.verification && (
                <div className={styles.verificationBadge}>
                  <FontAwesomeIcon icon={faShield} />
                </div>
              )}
            </div>

            <div className={styles.info}>
              <h3 className={styles.name}>
                {craftsman.first_name} {craftsman.last_name}
              </h3>
              
              <div className={styles.details}>
                <div className={styles.profession}>
                  <FontAwesomeIcon icon={faCrown} className={styles.icon} />
                  <span>{craftsman.profession}</span>
                </div>
                
                <div className={styles.location}>
                  <FontAwesomeIcon icon={faMapMarkerAlt} className={styles.icon} />
                  <span>{craftsman.city}</span>
                </div>
                
                {formattedRating && (
                  <div className={styles.rating}>
                    <FontAwesomeIcon icon={faStar} className={styles.icon} />
                    <span>{formattedRating}</span>
                  </div>
                )}
              </div>

              <div className={styles.additionalInfo}>
                <div className={styles.experience}>
                  <FontAwesomeIcon icon={faCalendarAlt} className={styles.icon} />
                  <span>გამოცდილება: {craftsman.experience} წელი</span>
                </div>

                <div className={styles.price}>
                  <span className={styles.priceLabel}>ფასი:</span>
                  <span className={styles.priceValue}>{craftsman.price} ლარი</span>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.actions}>
            <button 
              className={styles.viewProfileButton}
              onClick={handleViewProfile}
            >
              <FontAwesomeIcon icon={faCrown} className={styles.buttonIcon} />
              პროფილის ნახვა
            </button>
          </div>

        </div>
      </div>
    </div>
  );
});

PromotionalBanner.displayName = 'PromotionalBanner';

export default PromotionalBanner;